var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6782 30.1425C27.11 36.7413 23.719 39.4358 16.2954 39.4358H16.0571C7.86363 39.4358 4.58258 36.1547 4.58258 27.9613L4.58258 16.0102C4.58258 7.81676 7.86363 4.53571 16.0571 4.53571H16.2954C23.664 4.53571 27.055 7.19354 27.6599 13.6823",
    stroke: "#828282",
    strokeWidth: 2.74948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4966 22.0042L37.356 22.0042",
    stroke: "#828282",
    strokeWidth: 2.74948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2687 28.1448L39.4092 22.0043L33.2687 15.8638",
    stroke: "#828282",
    strokeWidth: 2.74948,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/LogoutIcon.63287712a7363c42f1f6e371c3a5d271.svg";
export { ForwardRef as ReactComponent };